import { AvailableChildrenType, SugarElementInfo } from "../../SugarElementInfo";

export const startTour: SugarElementInfo = {
    name: "startTour",
    availableChildren: { type: AvailableChildrenType.Any },
};
